var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSquareRoundCorners = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 80",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M64.1 59H31.8c-1.55 0-2.8-1.25-2.8-2.8V23.8c0-1.55 1.25-2.8 2.8-2.8h32.3a2.875 2.875 0 0 1 2.9 2.8v32.3c0 1.6-1.3 2.9-2.9 2.9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1 60H31.8c-2.07 0-3.75-1.68-3.75-3.75V23.8c0-2.07 1.68-3.75 3.75-3.75h32.33A3.87 3.87 0 0 1 68 23.77V56.1a3.863 3.863 0 0 1-3.82 3.9h-.08Zm0-38H31.8c-.98.03-1.77.82-1.8 1.8v32.4c0 1 .8 1.82 1.8 1.85h32.3c1.09 0 1.97-.87 2-1.95V23.8a1.935 1.935 0 0 0-2-1.8Z"
  })));
};
export default SvgSquareRoundCorners;